// rights.resolver.ts
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from 'app/services/user.service';
import { Constants } from 'app/utility/constants';
import { Observable, take, finalize, timeout } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RightsResolver implements Resolve<any>
{
    constructor(
        private userService: UserService,
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
    {
        return this.userService.getCachedRights()
        .pipe(
            timeout(Constants.ApiShortTimeout),
            take(1),
            finalize(() => true)
        );
    }
}
